const UPLOADING_STATUSES = {
  RUNNING: 'running',
  UPLOADING: 'uploading',
  DONE: 'done',
  ERROR: 'error'
}

export { UPLOADING_STATUSES }
export default UPLOADING_STATUSES
